export enum ErrorStatus {
  TechnicalError = 500,
  BadRequest = 400,
  Conflict = 409,
  Forbidden = 403,
  NotFound = 404,
  NotAllowed = 405,
  InsufficientStorage = 507,
  EntityTooLarge = 413,
  AccessDenied = 424,
  RedirectError = 412,
  Unauthorized = 401,
  GatewayTimeout = 504,
  Locked = 423,
  AdGatewayTimeout = 408,
  UserConflict = 909,
  UnprocessableEntity = 422,
  TokenExpired = 419,
}
